export default {
  PILOT: 'PILOT',
  DEMO: 'DEMO',
  PITO_UNEMPLOYED: 'PILOT_UNEMPLOYED',
}
